<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="8">
            <a-form-item :label="$t('label.batch')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag  :trigger-change="true" v-decorator="['breedBatchCode',validatorRules.breedBatchCode]" type="list" dictCode="efs_batch_settlement,batch_code_name,batch_code" placeholder="请输入批次" />
              <!-- <a-input v-decorator="['breedBatchCode']" placeholder="请输入批次"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleBreedBatchCodeChange" icon="search">结算</a-button>
            </span>
          </a-col>
        </a-row>
        <div style="margin-top: 17px;"><span style="color:black;font-size: 20px"><strong>批次信息：</strong></span></div>
        <a-row>

          <a-col :span="8">
            <a-form-item label="批次名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled v-decorator="['breedBatchName']" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="创建日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date disabled  v-decorator="['batchCreateDate']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="品类" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['breedVarietyCode',{'initialValue': initBreedVarietyCode}]" :trigger-change="true" dictCode="pzlx" />
        <!--      <a-input disabled v-decorator="['breedVarietyCode']" placeholder="请输入品类"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.breedingCycle')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['cycle']"  style="width: 93%"/> 周
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="进苗数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['realImpQuantity']"  style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="进苗日龄" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['realImpAge']"  style="width: 93%"/> 天
            </a-form-item>
          </a-col>
        </a-row>
        <div style="margin-top: 17px;"><span style="color:black;font-size: 20px"><strong>基本信息：</strong></span></div>
        <a-row>
          <a-col :span="8">
            <a-form-item :label="$t('label.grower')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['farmerCode',{'initialValue': initFarmerCode}]" :trigger-change="true" dictCode="efs_md_farmer,name,code" />
              <!--<a-input disabled v-decorator="['farmerCode']" placeholder="请输入养户"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.company')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['companyCode',{'initialValue': initCompanyCode}]" :trigger-change="true" dictCode="sys_depart,depart_name,org_code" />
              <!--<a-input disabled v-decorator="['companyCode']" placeholder="请输入公司"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="养户地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled v-decorator="['familyAddress']" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.farms')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['farmCode',{'initialValue': initFarmCode}]" :trigger-change="true" dictCode="sys_depart,depart_name,org_code" />
             <!-- <a-input disabled v-decorator="['farmCode']" placeholder="请输入养殖场"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="养殖场地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled v-decorator="['farmAddress']" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="养户电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled v-decorator="['farmerPhone']" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.settlementAmount')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['settlementAmount']"  style="width: 93%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.documentNo')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled v-decorator="['orderCode']" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.stocker')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['managerCode',{'initialValue': initManagerCode}]" :trigger-change="true" dictCode="sys_user,realname,username" />
              <!--<a-input disabled v-decorator="['managerCode']" placeholder="请输入放养员"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.contracts')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['contractCode',{'initialValue': initContractCode}]" :trigger-change="true" dictCode="efs_md_contract,name,code" />
              <!--<a-input disabled v-decorator="['contractCode']" placeholder="请输入合同编号"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.totalWeight')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['sumWeight']"  style="width: 93%"/> 斤
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.unitPrice')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['salePrice']"  style="width: 87%"/> {{ $t('label.rmbKilo') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="税价合计" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['totalAmt']"  style="width: 93%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="税价合计·大写" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled v-decorator="['totalAmtCn']" ></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <div style="margin-top: 17px;"><span style="color:black;font-size: 20px"><strong>养殖成绩：</strong></span></div>
          <a-row>
          <a-col :span="8">
            <a-form-item :label="$t('label.numberOfSlaughter')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['outNumber']"  style="width: 93%"/>  只
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="日龄" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['dayAge']"  style="width: 93%"/> 天
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="出栏均重" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['aveWeight']"  style="width: 92%"/> kg
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="日增重" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['addWeight']"  style="width: 92%"/> kg
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="料肉比" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['mfRatio']"  style="width: 94%"/> %
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="出栏率" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['outRatio']"  style="width: 94%"/> %
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="次品率" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['badRatio']"  style="width: 94%"/> %
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.docCost')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['chickCost']"  style="width: 93%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="饲料成本" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['feedCost']"  style="width: 93%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="动保成本" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['insuranceCost']"  style="width: 93%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.costAmount')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['feeAmount']"  style="width: 93%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="奖励金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['awardAmount']"  style="width: 93%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.subsidyAmount')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['subsidyAmount']"  style="width: 93%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="处罚金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['punishmentAmount']"  style="width: 93%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="托养费用" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['fosterCareFee']"  style="width: 93%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="分红" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['distributeDividends']"  style="width: 93%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="利润共享" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['profitShare']"  style="width: 93%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="保证金" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['bond']"  style="width: 93%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="扣减保证金" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['substractBond']"  style="width: 93%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="结算保证金" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['settlementBond']"  style="width: 93%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="已计提费用" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['pedFee']"  style="width: 93%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="结算费用" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['settlementFee']"  style="width: 93%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="计提差额" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['peDifference']"  style="width: 93%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="动保费用" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['insuranceFee']"  style="width: 93%"/> 元
            </a-form-item>
          </a-col>
        <!--  <a-col :span="8">
            <a-form-item label="锁定状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled v-decorator="['lockStauts']" ></a-input>
            </a-form-item>
          </a-col>-->
          <a-col :span="8">
            <a-form-item :label="$t('label.remarks')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input  v-decorator="['notes']" :placeholder="$t('label.pleaseEnterANote')"></a-input>
            </a-form-item>
          </a-col>


          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{$t('button.submit')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"

  export default {
    name: 'EfsStlBatchSettlementForm',
    components: {
      JFormContainer,
      JDate,
      JDictSelectTag,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
            breedBatchCode: {rules: [{required: true, message: this.$t('label.pleaseSelectBatchCode')}]},
        },
        url: {
          add: "/batchSettlement/efsStlBatchSettlement/add",
          edit: "/batchSettlement/efsStlBatchSettlement/edit",
          queryById: "/batchSettlement/efsStlBatchSettlement/queryById",
          queryBreedBatchCode: "/batchSettlement/efsStlBatchSettlement/queryBreedBatchCode",
        },
          initBreedVarietyCode:null,
          initFarmerCode:null,
          initCompanyCode:null,
          initFarmCode:null,
          initManagerCode:null,
          initContractCode:null,
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        if(!this.model.id){
            this.initBreedVarietyCode=null;
            this.initFarmerCode=null;
            this.initCompanyCode=null;
            this.initFarmCode=null;
            this.initManagerCode=null;
            this.initContractCode=null;
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'createBy','createTime','updateBy','updateTime','sysOrgCode','breedBatchCode','breedBatchName','batchCreateDate','breedVarietyCode','cycle','realImpQuantity','realImpAge','farmerCode','companyCode','familyAddress','farmCode','farmAddress','farmerPhone','settlementAmount','orderCode','managerCode','contractCode','outNumber','dayAge','aveWeight','addWeight','mfRatio','outRatio','badRatio','chickCost','feedCost','insuranceCost','feeAmount','awardAmount','subsidyAmount','punishmentAmount','fosterCareFee','distributeDividends','profitShare','bond','substractBond','settlementBond','pedFee','settlementFee','peDifference','insuranceFee','lockStauts','buffer1','buffer2','buffer3','buffer4','buffer5','notes','validFlag','delFlag','sumWeight','salePrice','totalAmt','totalAmtCn'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'createBy','createTime','updateBy','updateTime','sysOrgCode','breedBatchCode','breedBatchName','batchCreateDate','breedVarietyCode','cycle','realImpQuantity','realImpAge','farmerCode','companyCode','familyAddress','farmCode','farmAddress','farmerPhone','settlementAmount','orderCode','managerCode','contractCode','outNumber','dayAge','aveWeight','addWeight','mfRatio','outRatio','badRatio','chickCost','feedCost','insuranceCost','feeAmount','awardAmount','subsidyAmount','punishmentAmount','fosterCareFee','distributeDividends','profitShare','bond','substractBond','settlementBond','pedFee','settlementFee','peDifference','insuranceFee','lockStauts','buffer1','buffer2','buffer3','buffer4','buffer5','notes','validFlag','delFlag','sumWeight','salePrice','totalAmt','totalAmtCn'))
      },
        handleBreedBatchCodeChange() {
          let value=this.form.getFieldsValue().breedBatchCode;
          if(value){
              getAction(this.url.queryBreedBatchCode, { breedBatchCode: value }).then(res => {
                  if (res.success) {
                          this.form.resetFields();
                          this.initBreedVarietyCode=res.result.breedVarietyCode,
                          this.initFarmerCode=res.result.farmerCode,
                          this.initCompanyCode=res.result.companyCode,
                          this.initFarmCode=res.result.farmCode,
                          this.initManagerCode=res.result.managerCode,
                          this.initContractCode=res.result.contractCode,
                          this.form.setFieldsValue({
                              breedBatchCode:res.result.batchCode,
                              breedBatchName:res.result.batchCodeName,
                              batchCreateDate:res.result.batchCreateDate,
                              cycle:res.result.cycle,
                              realImpQuantity:res.result.realImpQuantity,
                              realImpAge:res.result.realImpAge,
                              familyAddress:res.result.familyAddress,
                              farmAddress:res.result.farmAddress,
                              farmerPhone:res.result.farmerPhone,
                              settlementAmount:res.result.settlementAmount,
                              orderCode:res.result.orderCode,
                              outNumber:res.result.outNumber,
                              dayAge:res.result.dayAge,
                              aveWeight:res.result.aveWeight,
                              addWeight:res.result.addWeight,
                              mfRatio:res.result.mfRatio,
                              outRatio:res.result.outRatio,
                              badRatio:res.result.badRatio,
                              chickCost:res.result.chickCost,
                              feedCost:res.result.feedCost,
                              insuranceCost:res.result.insuranceCost,
                              feeAmount:res.result.feeAmount,
                              awardAmount:res.result.awardAmount,
                              subsidyAmount:res.result.subsidyAmount,
                              punishmentAmount:res.result.punishmentAmount,
                              fosterCareFee:res.result.fosterCareFee,
                              distributeDividends:res.result.distributeDividends,
                              profitShare:res.result.profitShare,
                              bond:res.result.bond,
                              substractBond:res.result.substractBond,
                              settlementBond:res.result.settlementBond,
                              pedFee:res.result.pedFee,
                              settlementFee:res.result.settlementFee,
                              peDifference:res.result.peDifference,
                              insuranceFee:res.result.insuranceFee,
                              lockStauts:res.result.lockStauts,
                              sumWeight:res.result.sumWeight,
                              salePrice:res.result.salePrice,
                              totalAmt:res.result.totalAmt,
                              totalAmtCn:res.result.totalAmtCn,
                          });
                  }
              })
          }else{
              this.$message.warning("请选择批次号!");
          }

        },
    }
  }
</script>